"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

export default function ScrollToTop() {
  const pathname = usePathname();

  useEffect(() => {
    // We use a small timeout to ensure the DOM has updated
    // and layout is stable before scrolling
    const timer = setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant", // We want it to be instant to avoid partial scrolls
      });
    }, 10);

    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
}
